// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Xe-z","heading":"Ye-z","brandPromo":"Ze-z"};